
import { WorldCountry } from './types';

export const saudiArabiaData: WorldCountry = {
  code: 'SA',
  name: 'Saudi Arabia',
  slug: 'saudi-arabia',
  population: 34813871,
  topCities: [
    { name: 'Riyadh', slug: 'riyadh', population: 7676654 },
    { name: 'Jeddah', slug: 'jeddah', population: 4697000 },
    { name: 'Mecca', slug: 'mecca', population: 2042106 },
    { name: 'Medina', slug: 'medina', population: 1488782 },
    { name: 'Dammam', slug: 'dammam', population: 1252523 },
    { name: 'Khobar', slug: 'khobar', population: 409549 },
    { name: 'Tabuk', slug: 'tabuk', population: 569797 },
    { name: 'Khamis Mushait', slug: 'khamis-mushait', population: 387553 },
    { name: 'Hail', slug: 'hail', population: 310897 },
    { name: 'Hafar Al-Batin', slug: 'hafar-al-batin', population: 271642 }
  ]
};
